import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlBindRichtext", function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.addClass("tl-richtext-container");
      $scope.$watch($attrs.tlBindRichtext, function tlBindRichtextWatchAction(value) {
        $el.html(value);
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/richtext/tl-bind-richtext.js
// module id = 2986
// module chunks = 13